import { Box, Grid, List, Typography } from '@mui/material';
import DateFormatter from '@apigrowfinance/pbolt-date-formatter';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';

import { StatementItemType } from '@clients/statementsClient';
import StatementHeader from '@components/accountStatements/StatementHeader';
import StatementTransactions from '@components/accountStatements/StatementTransactions';
import { useAccount } from '@contexts/AccountProvider';

type StatementItemProps = {
    statement: StatementItemType;
    accountId: number;
    fetchNextStatement: () => void;
};

const StatementItem = ({
    statement,
    accountId,
    fetchNextStatement,
}: StatementItemProps) => {
    const { program } = useAccount();
    const { theme } = useTheme();
    const currencyCode = program?.currency_numeric_code;
    return (
        <Grid
            item
            xs={12}
            key={statement.statement_id}
            sx={{
                mt: 3,
                mb: 3,
                color: theme?.custom?.brand?.textMain || 'text.primary',
            }}>
            <Typography
                variant="overline"
                data-testid="statement-month-typography">
                <DateFormatter date={statement?.calendar?.cycle_closing_date} />
            </Typography>
            <Box
                sx={{
                    mt: 2,
                    bgcolor: 'background.paper',
                    width: '100%',
                }}>
                <List>
                    <StatementHeader
                        statement={statement}
                        currencyCode={currencyCode}
                    />
                    <StatementTransactions
                        statement={statement}
                        accountId={accountId}
                        fetchNextStatement={fetchNextStatement}
                    />
                </List>
            </Box>
        </Grid>
    );
};

export default StatementItem;
